import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from '@reduxjs/toolkit'
import { HttpService } from "../../services/HttpService";
import Store from "..";

const pageList: number = Number(process.env.REACT_APP_PAGE_LIST) || 10;

const initialState = {
  listPharmacies: [],
  active: "",
  search: "",
  pageTotal: 0,
  pageIndex: 1
}

export const loadPharmacies = (pageIndex: Number) => async (dispacth: any) => {
  try {
    const search = Store.getState().pharmacies.search;
    const active = Store.getState().pharmacies.active;
    const resposelistPharmacies = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/paginated?page=${pageIndex}&itemsPerPage=${pageList}&search=${search}&active=${active}`);
    if (resposelistPharmacies.data) {
      dispacth(updatePharmacies(resposelistPharmacies.data.result));
      dispacth(updatePageIndex(pageIndex))
      let totalItems = Number(resposelistPharmacies.data.count);
      dispacth(updateCountPharmacies(Math.ceil(totalItems / pageList)))
    }
  }
  catch (e) {
    console.log("Load Pharmacies", e);
  }
}

export const searchLoadPharmacies = (search: string) => async (dispacth: any) => {
  try {
    const pageIndex = Store.getState().pharmacies.pageIndex;
    await dispacth(updateSearchPharmacies(search));
    await dispacth(loadPharmacies(pageIndex))
  }
  catch (e) {
    console.log("Search  Pharmacies", e);
  }
}

export const activeFilterPharmacies = (active: string) => async (dispacth: any) => {
  try {
    const pageIndex = Store.getState().pharmacies.pageIndex;
    await dispacth(updateActiveFilter(active));
    await dispacth(loadPharmacies(pageIndex))
  }
  catch (e) {
    console.log("Search  Pharmacies", e);
  }
}

export const updateStatusPharmacies = (status: boolean, idEvent: string) => async (dispacth: any) => {
  try {
    const listPharmacies = Store.getState().pharmacies.listPharmacies;
    const resposePharmacies = await HttpService.put(`${process.env.REACT_APP_API}/t4event/api/v01/event/${idEvent}/toogle/active/${status}`, {});
    let pharmacies: any[] = [];
    if (resposePharmacies.status === 200) {
      for (let index = 0; index < listPharmacies.length; index++) {
        let element: any = Object.assign({}, listPharmacies[index]);
        if (element._id === idEvent) {
          console.log(element);
          element.active = status
        }
        pharmacies.push(element)
      }
    }
    await dispacth(updatePharmacies(pharmacies));
  }
  catch (e) {
    console.log("Load Pharmacies", e);
  }
}


const pharmaciesReducer = createSlice({
  name: 'Pharmacies',
  initialState,
  reducers: {
    updateActiveFilter(state, action: PayloadAction<any>) {
      state.active = action.payload;
    },
    updatePharmacies(state, action: PayloadAction<any>) {
      state.listPharmacies = action.payload;
    },
    updateCountPharmacies(state, action: PayloadAction<any>) {
      state.pageTotal = action.payload;
    },
    updateSearchPharmacies(state, action: PayloadAction<any>) {
      state.search = action.payload;
    },

    updatePageIndex(state, action: PayloadAction<any>) {
      state.pageIndex = action.payload;
    },


  }
})
export const { updateActiveFilter, updatePharmacies, updateSearchPharmacies, updateCountPharmacies, updatePageIndex } = pharmaciesReducer.actions
export default pharmaciesReducer.reducer